<script setup lang="ts">
import { ref } from 'vue'

import { useVuelidate } from '@vuelidate/core'
import { required, integer, alphaNum, minLength, maxLength } from '@vuelidate/validators'

import Barcode from '@material-symbols/svg-400/rounded/barcode_scanner.svg'
import Key from '@material-symbols/svg-400/rounded/key.svg'

import LoadingButton from './LoadingButton.vue';

import TextInput from './form_inputs/TextInput.vue'

import { state } from '../state'

import { fetchResult } from '../fetch'

const emit = defineEmits<{
  (event: 'onClickNext'): void
}>()

const rules = {
  barcode: { required, alphaNum, maxLength: maxLength(30) },
  pinCode: { required, integer, minSize: minLength(4), maxSize: maxLength(8) }
}

const v$ = useVuelidate(rules, state)

const loading = ref(false)
const missingResult = ref(false)

async function onSubmit() {
  if (await v$.value.$validate()) {
    loading.value = true
    const result = await fetchResult({barcode: state.barcode, pin: state.pinCode});
    loading.value = false;
    if (result) {
      state.result = result;
      emit('onClickNext');
    } else {
      missingResult.value = true;
    }
  }
}
</script>

<template>
  <form @submit.prevent @submit="onSubmit">
    <div class="pt-8 pb-2 text-base text-gray-600 text-center w-">
      <p class="dark:text-gray-300">Enter your barcode to view the test result.</p>
    </div>
    <div class="space-y-0 flex justify-center">
      <div class="w-96">
        <TextInput
          id="barcode"
          v-model="state.barcode"
          :icon="Barcode"
          placeholder="Barcode"
          input-class="text-2xl pl-14"
          icon-class="w-11 h-11 p-2"
          :errors="v$.barcode.$errors.map<any>((e) => e.$message)"
        />
      </div>
    </div>
    <div class="space-y-0 flex justify-center">
      <div class="w-96">
        <TextInput
          type="password"
          id="pinCode"
          v-model="state.pinCode"
          :icon="Key"
          placeholder="Your PIN"
          input-class="text-2xl pl-14"
          icon-class="w-11 h-11 p-2"
          :errors="v$.pinCode.$errors.map<any>((e) => e.$message)"
        />
      </div>
    </div>
    <div class="error-text text-center" v-if="missingResult">
      There is no result available for the specified barcode. Please check again later.
    </div>
    <div class="flex justify-center my-4 text-sm">
      <LoadingButton :loading="loading">Show result</LoadingButton>
    </div>
  </form>
</template>

